import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-loading-field',
  templateUrl: './loading-field.component.html',
  styleUrls: ['./loading-field.component.scss']
})
export class LoadingFieldComponent {
  
  @Input() loading = true;
}
